/* Skillbuilder: reusable modal system
Trigger link attributes:
	- data-sb-modal
	- data-sb-title="Modal title"
	- data-sb-content-id="id-of-hidden-content"

Also supports plain hash links for editor-friendly sections (like multicolumn):
	- href="#sb-..." (example: #sb-pf-ld-manager)

Content source:
	- sections/sb-modal-content.liquid (section name: "SB")
	- Each block "M" outputs <div id="...">...</div> inside a hidden store

Page example:
	- Personalised feedback modals:
		sb-pf-ld-manager
		sb-pf-pro-growth
		sb-pf-career-changer
*/

const sbModalTitles = {
	'sb-pf-ld-manager': 'The Learning and Development Manager Pathway',
	'sb-pf-pro-growth': 'The Professional Growth Pathway',
	'sb-pf-career-changer': 'The Career Changer’s Pathway'
}

function sbModalOpen(trigger) {
	const modal = document.getElementById('sb-modal')
	if (!modal) return

	const titleEl = document.getElementById('sb-modal-title')
	const contentEl = document.getElementById('sb-modal-content')

	const contentId = trigger.getAttribute('data-sb-content-id')
	const title =
		trigger.getAttribute('data-sb-title') ||
		(sbModalTitles[contentId] || '')

	const source = contentId ? document.getElementById(contentId) : null

	if (titleEl) titleEl.textContent = title
	if (contentEl) contentEl.innerHTML = source ? source.innerHTML : ''

	modal.classList.add('is-open')
	modal.setAttribute('aria-hidden', 'false')
	document.documentElement.classList.add('sb-modal-lock')
}

function sbModalClose() {
	const modal = document.getElementById('sb-modal')
	if (!modal) return

	modal.classList.remove('is-open')
	modal.setAttribute('aria-hidden', 'true')
	document.documentElement.classList.remove('sb-modal-lock')
}

document.addEventListener('click', (e) => {
	const modal = document.getElementById('sb-modal')
	if (!modal) return

	const panel = modal.querySelector('.sb-modal__panel')
	const closer = e.target.closest('[data-sb-close]')
	const trigger = e.target.closest('[data-sb-modal]')

	// 1) Editor-friendly hash links: <a href="#sb-...">
	const hashLink = e.target.closest('a[href^="#sb-"]')
	if (hashLink) {
		e.preventDefault()

		const contentId = hashLink.getAttribute('href').replace('#', '')
		const fakeTrigger = document.createElement('a')
		fakeTrigger.setAttribute('data-sb-content-id', contentId)

		sbModalOpen(fakeTrigger)
		return
	}

	// 2) Explicit close elements
	if (closer) {
		e.preventDefault()
		sbModalClose()
		return
	}

	// 3) Explicit triggers with data attributes
	if (trigger) {
		e.preventDefault()
		sbModalOpen(trigger)
		return
	}

	// 4) Click outside the panel closes the modal
	if (modal.classList.contains('is-open') && panel && !panel.contains(e.target)) {
		sbModalClose()
	}
})

document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape') sbModalClose()
})